import type { Product, ProductSlots } from './adapters/product-types';
import { ProductListView } from './views/product-list-view';
import { ProductTableView } from './views/product-table-view';

export type ProductProps = {
  product: Product;

  slots?: ProductSlots;
};

export function Product({ product, slots }: ProductProps) {
  return product.items.length > 2 ? (
    <ProductTableView product={product} slots={slots} />
  ) : (
    <ProductListView product={product} slots={slots} />
  );
}
